import request from '@/plugin/axios'

export function getMenuList (data) {
  return request({
    url: '/moblieapp/menu',
    method: 'post',
    data: data,
    loading: {
      type: 'loading',
      options: {
        fullscreen: true,
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)'
      }
    }
  })
}
export function getMenuListNew (data) {
  return request({
    url: '/moblieapp/menuNew',
    method: 'post',
    data: data,
    loading: {
      type: 'loading',
      options: {
        fullscreen: true,
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)'
      }
    }
  })
}
export function getMenu (data) {
  return request({
    url: '/moblieapp/menuid',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}
export function saveMenu (data) {
  return request({
    url: '/moblieapp/menuSave',
    method: 'post',
    data,
    loading: {
      type: 'nprogress',
      interval: 1000
    },
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}
export function delMenu (data) {
  return request({
    url: '/moblieapp/delMenu',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}
